<div class="dynamic-reviews-display-conditions">
  <pdq-card variant="popover" color="white">
    <div class="card-header">
      <pdq-heading element="h5">Display Conditions</pdq-heading>
      <span class="subtitle body-13-regular">This extension will only appear if:</span>
    </div>
    <pdq-divider></pdq-divider>

    <div class="card-content">
      <pdq-rules-dynamic-form
        [formGroup]="formGroup"
        formArrayFieldName="displayRules"
        [rules]="displayRules"
        [entities]="displayRulesEntities"
        [versionWithOrOperator]="true"></pdq-rules-dynamic-form>
    </div>
  </pdq-card>
</div>
